module.exports = __webpack_public_path__ + "static/img/Teacher.333f44f9.png";